import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { InstallationFeaturesStore } from '@store';
import {
  FeatureNames,
  FeaturePropertyKey,
} from '@vi-iot/client/apis/operational-data/operational-data.constants';
import {
  DcSensorValueProperties,
  Feature,
} from '@vi-iot/client/apis/operational-data/operational-data.model';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-ventilation-sensor-readings',
  templateUrl: './ventilation-sensor-readings.component.html',
  styleUrls: ['./ventilation-sensor-readings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VentilationSensorReadingsComponent implements OnInit {
  readonly featurePropertyKey = FeaturePropertyKey;

  ventilationSensorsTemperatureSupply$: Observable<Feature<DcSensorValueProperties, never>>;
  ventilationSensorsHumiditySupply$: Observable<Feature<DcSensorValueProperties, never>>;
  ventilationSensorsTemperatureOutside$: Observable<Feature<DcSensorValueProperties, never>>;
  ventilationSensorsHumidityOutdoor$: Observable<Feature<DcSensorValueProperties, never>>;
  ventilationSensorsTemperatureExhaust$: Observable<Feature<DcSensorValueProperties, never>>;
  ventilationSensorsHumidityExhaust$: Observable<Feature<DcSensorValueProperties, never>>;
  ventilationSensorsTemperatureExtract$: Observable<Feature<DcSensorValueProperties, never>>;
  ventilationSensorsHumidityExtract$: Observable<Feature<DcSensorValueProperties, never>>;
  constructor(private installationFeaturesStore: InstallationFeaturesStore) {}

  ngOnInit(): void {
    this.ventilationSensorsTemperatureSupply$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.ventilationSensorsTemperatureSupply
    );
    this.ventilationSensorsHumiditySupply$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.ventilationSensorsHumiditySupply
    );
    this.ventilationSensorsTemperatureOutside$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.ventilationSensorsTemperatureOutside
    );
    this.ventilationSensorsHumidityOutdoor$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.ventilationSensorsHumidityOutdoor
    );
    this.ventilationSensorsTemperatureExhaust$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.ventilationSensorsTemperatureExhaust
    );
    this.ventilationSensorsHumidityExhaust$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.ventilationSensorsHumidityExhaust
    );
    this.ventilationSensorsTemperatureExtract$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.ventilationSensorsTemperatureExtract
    );
    this.ventilationSensorsHumidityExtract$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.ventilationSensorsHumidityExtract
    );
  }
}
